import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import {t} from "../../../../../../../services/i18n";
import VStack from "../../../../../../common/Layout/VStack";
import DropDownMenu from "../../../../../../common/DropDownMenu";
import {isMobile} from "../../../../../../../services/Helpers";
import usePermissions from "../../../../../../../services/Permissions";
import {SCHEDULE_VIEW_CANDIDATES} from "../../../../../../../services/ScheduleService";
import {
    AVAILABILITY_TYPE,
    DEFAULT_SCHEDULE_VIEW,
    MIX_TYPE,
    SCHEDULE_TYPE,
    SPACES_TYPE
} from "../../../../../../../services/ConstHelper";
import {toggleScheduleLoader, toggleSuccessFlag} from "../../../../../../../redux/ScheduleSlice";
import {fetchApi} from "../../../../../../../services/HTTP";
import {updateBox} from "../../../../../../../redux/boxSlice";
import {store} from "../../../../../../../redux/store";

const VIEW_LABELS = {
    [SCHEDULE_TYPE]: 'schedule',
    [MIX_TYPE]: 'availability-mix',
    [AVAILABILITY_TYPE]: 'availability',
    [SPACES_TYPE]: 'spaces',
};

const DefaultScheduleView = (props) => {
    const { values, setFieldValue } = props;
    const shouldSave = useSelector((state) => state.schedule.settingsSaveFlag);
    const dispatch = useDispatch();
    const { has, hasLock } = usePermissions();

    const options = useMemo(() => SCHEDULE_VIEW_CANDIDATES
        .filter(candidate => has(candidate.perm) && (!candidate.lock || !hasLock(candidate.lock)))
        .map(candidate => ({ id: candidate.type, name: t(VIEW_LABELS[candidate.type]) }))
        , [has, hasLock]);

    const selectedLabel = useMemo(
        () => options.find(option => option.id === values?.defaultScheduleView)?.name,
        [options, values?.defaultScheduleView]
    );

    useEffect(() => {
        if (shouldSave) save();
    }, [shouldSave]);

    const save = async () => {
        try {
            if (isMobile) {
                dispatch(toggleScheduleLoader(true));
                const setting = { prop_name: DEFAULT_SCHEDULE_VIEW, properties: { type: values.defaultScheduleView } };
                await fetchApi(`boxes/settings`, 'POST', setting, false, true);
                dispatch(toggleScheduleLoader(false));
                dispatch(toggleSuccessFlag(true));
                dispatch(updateBox({
                    settings: {
                        ...store.getState().box.box.settings,
                        [DEFAULT_SCHEDULE_VIEW]: setting.properties
                    }
                }));
            }
        } catch (error) {
            dispatch(toggleScheduleLoader(false));
        }
    };

    return (
        <VStack space={'0.5rem'}>
            <DropDownMenu
                title={selectedLabel}
                items={options}
                onPress={(val) => setFieldValue('defaultScheduleView', val)}
                fontSize={GlobalStyleAttributes.fonts.standard16}
                showBorder
                styleOverride={isMobile ? null : { width: '12rem' }}
            />
        </VStack>
    );
};

export default DefaultScheduleView;
